import { map } from 'lodash';
import { getApplicationById } from './applications';

export const getApplicants = (state, openingId) => {
  const openingApplicants = state.applicants[openingId];

  return map(openingApplicants, applicant => {
    return {
      ...applicant,
      application: getApplicationById(state, applicant.application).application,
    };
  });
};

export const getApplicantsLoading = state => state.applicants.loading;
